// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__23-Ru","inner":"Form_inner__SnthF","range":"Form_range__2ErJ3","name":"Form_name__1-u-8","actions":"Form_actions__3M1nN"};